<template>
    <vs-prompt
        @accept="submit"
        :active.sync="localActive"
        title="Vendor Warehouse Details"
        accept-text="Confirm"
    >
        <div class="con-exemple-prompt" v-if="outbound">
            <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Reference:</label>
                <p class="font-semibold">{{ outbound.outbound_reference }}</p>
            </div>

            <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Origin Warehouse:</label>
                <p class="font-semibold">{{ outbound.origin ? outbound.origin.name : 'N/A' }}</p>
            </div>

            <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Jumlah Product:</label>
                <p class="font-semibold">{{ totalQty }}</p>
            </div>

            <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Vendor/Transporter:</label>
                <p class="font-semibold">{{ transporterLabel }}</p>
            </div>
        </div>
    </vs-prompt>
</template>

<script>
export default {
    name: "VendorWarehouseModal",

    props: {
        active: Boolean,
        outbound: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            localActive: false
        };
    },

    computed: {
        transporterLabel() {
            if (!this.outbound || !this.outbound.transporter) {
                return '-';
            }
            const t = this.outbound.transporter;
            return `${t.transporter_code} - ${t.name}`;
        },
        
        totalQty() {
            if (!this.outbound || !this.outbound.details) return 0;
            return this.outbound.details.reduce((sum, item) => sum + item.base_qty, 0);
        }
    },

    watch: {
        active(val) {
            this.localActive = val;
        },
        localActive(val) {
            this.$emit('update:active', val);
        }
    },

    methods: {
        submit() {
            this.$emit('submit', {
                outbound_id: this.outbound.id,
            });
        }
    }
};
</script>